// Visitor tracking ping — one POST to the same-origin /__visit Cloud Function
// (see frontend/functions/index.js) per route change, throttled per path.
// The function owns identity (IP+UA hash), geo lookup, and the Firestore
// write; the client only sends the path and a few harmless hints. Fire-and-
// forget: tracking must never affect the app, so every failure is swallowed
// (including localhost dev, where the Hosting rewrite doesn't exist).
const PING_TTL_MS = 30 * 60 * 1000; // re-ping the same path after 30 min
const lastPing = new Map(); // path -> ms

export function trackVisit(pathname, user) {
  try {
    const now = Date.now();
    if (now - (lastPing.get(pathname) || 0) < PING_TTL_MS) return;
    lastPing.set(pathname, now);
    const body = JSON.stringify({
      p: pathname,
      r: document.referrer || '',
      lang: navigator.language || '',
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      sw: window.screen?.width || 0,
      sh: window.screen?.height || 0,
      ...(user ? { uid: user.uid, email: user.email || '' } : {}),
    });
    fetch('/__visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never let tracking break the app */
  }
}
